(() => {
  'use strict';
  const marketForm = document.getElementById('BfgMarketForm');
  const currencyCountries = { USD: 'US', CAD: 'CA', GBP: 'GB', EUR: 'IE', AUD: 'AU', NZD: 'NZ' };
  document.addEventListener('click', event => {
    const link = event.target.closest('a.currency-item[data-currency]');
    const country = link && currencyCountries[link.dataset.currency];
    if (!marketForm || !country) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    marketForm.querySelector('[name="country_code"]').value = country;
    const returnTo = marketForm.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search;
    marketForm.submit();
  }, true);
  const drawer = document.getElementById('nt_menu_canvas');
  if (!drawer) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  const launcher = document.querySelector('[data-id="#nt_menu_canvas"]');
  const sync = () => {
    if (launcher) {
      launcher.setAttribute('aria-controls', 'nt_menu_canvas');
      launcher.setAttribute('aria-expanded', String(drawer.classList.contains('act_opened')));
    }
    drawer.querySelectorAll('.menu-item-has-children').forEach((item, index) => {
      const control = item.querySelector(':scope > a');
      const panel = item.querySelector(':scope > ul');
      if (!control || !panel) return;
      if (!panel.id) panel.id = 'bfg-menu-panel-' + index;
      control.setAttribute('aria-controls', panel.id);
      control.setAttribute('aria-expanded', String(item.classList.contains('nt_opended')));
    });
  };
  const close = () => {
    document.querySelector('.close_mn_t4')?.click();
    launcher?.focus({ preventScroll: true });
  };
  drawer.addEventListener('click', event => {
    if (event.target.closest('.bfg-menu-close')) close();
  });
  drawer.addEventListener('keydown', event => {
    if (!mobile.matches) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === ' ' && event.target.matches('.menu-item-has-children > a')) {
      event.preventDefault();
      event.target.click();
    }
  });
  new MutationObserver(sync).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  sync();
})();

